import { useToast } from '@chakra-ui/react';
import { showToast } from '@diamond/shared/ui';
import { useNavigate } from 'react-router-dom';

import { useCreateLHCMutation } from '../../hooks';
import type { CreateLHCModalProps } from '../../types';
import { LHCFormModal } from '../lhc-form-modal';

export function CreateLHCModal({
  isOpen,
  onClose,
  plantOptions,
  lastSyncedAt,
  onSync,
  isDuplicate = false,
  sourceLhcData,
  onDuplicate,
  duplicateMutationPending = false,
}: CreateLHCModalProps) {
  const toast = useToast();
  const navigate = useNavigate();

  const createLHCMutation = useCreateLHCMutation({
    onSuccess: (data) => {
      showToast(toast, 'success', 'LHC berhasil dibuat');
      onClose();
      navigate(`/collection-management/${data.id}`);
    },
    onError: (error) => {
      showToast(toast, 'error', error.message || 'Gagal membuat LHC');
    },
  });

  return (
    <LHCFormModal
      isOpen={isOpen}
      onClose={onClose}
      mode={isDuplicate ? 'duplicate' : 'create'}
      title={
        isDuplicate
          ? 'Duplikat Laporan Harian Collection'
          : 'Buat Laporan Harian Collection'
      }
      name={isDuplicate ? 'duplicate-lhc-modal' : 'create-lhc-modal'}
      submitLabel={isDuplicate ? 'Proses Duplikat' : 'Proses LHC Baru'}
      plantOptions={plantOptions}
      initialValues={
        isDuplicate && sourceLhcData
          ? {
              lhcNo: sourceLhcData.lhcNo,
              lhcDate: sourceLhcData.lhcDateRaw,
              collectionPlantId: sourceLhcData.collectionPlantId,
            }
          : null
      }
      isSubmitting={
        isDuplicate ? duplicateMutationPending : createLHCMutation.isPending
      }
      lastSyncedAt={lastSyncedAt}
      sourceLhcNo={isDuplicate ? sourceLhcData?.lhcNo : undefined}
      onSync={onSync}
      onSubmit={({ lhcNo, lhcDate, collectionPlantId }) => {
        if (isDuplicate && onDuplicate) {
          onDuplicate({
            lhc_no: lhcNo,
            lhc_date: lhcDate,
            plant_id: collectionPlantId,
          });
          return;
        }

        createLHCMutation.mutate({
          lhc_no: lhcNo,
          lhc_date: lhcDate,
          collection_plant_id: collectionPlantId,
        });
      }}
    />
  );
}
